import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { RegisterService } from '@core/services/register.service';

export const registerGuard: CanActivateFn = () => {
  const router = inject(Router);
  const registerService = inject(RegisterService);

  const isValidToken = registerService.validateRegisterVerificationToken();
  if (!isValidToken) {
    return true;
  }

  return router.createUrlTree(['/register/form']);
};
